export default "/static/assets/lead_engagement_output.9d8badfbaf781ae8acdeddd09a1f8c94.png";